import { ProductUpdate } from './product-update.model';

/**
 * Defines members of AccountGroup used for update application or card.
 *
 * There is no need to have account group identification now (according to Tomas Valenta).
 *
 * https://int0csaspsd2selfservice.docs.apiary.io/#reference/aisp/pisp
 *          /nastaveni-opravneni-smazani-aplikace/nastaveni-opravneni-k-uctum-pro-danou-aplikaci-a-klienta
 *
 * ### Example
 *
 * ```
 *  {
 *     'products': ProductUpdate[]
 *  }
 * ```
 */
export class AccountGroupUpdate {
    products: ProductUpdate[];

    constructor(products: ProductUpdate[]) {
        this.products = products;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/account-group/account-group-update.model.ts